import { hideVisually } from 'polished'
import styled, { css } from 'styled-components'

const ProgressWrapper = styled.div`
  ${({ theme }) => css`
    ${theme.maxMedia('sm')} {
      ${hideVisually()}
    }
  `}
`

const Header = styled.header`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacing(3)};
    width: 100%;
    padding: ${theme.spacing(3)} ${theme.spacing(5)};
    background-color: ${theme.palette.grey[800]};
    color: ${theme.palette.white};

    ${theme.media('sm')} {
      display: block;
      padding: ${theme.spacing(7)} 0;
      background-color: transparent;
      color: currentColor;
      text-align: center;
      max-width: 48rem;
    }

    svg {
      flex-shrink: 0;
      min-width: 6.4rem;
      width: 100%;

      ${theme.media('sm')} {
        ${hideVisually()}
      }
    }
  `}
`

const Title = styled.h2`
  ${({ theme }) => css`
    margin: 0;
    font-weight: 400;
    margin-bottom: ${theme.spacing(1)};

    ${theme.maxMedia('sm')} {
      font-size: 2.7rem;
    }
  `}
`

const Intro = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-weight: 300;

    ${theme.maxMedia('sm')} {
      ${hideVisually()}
    }
  `}
`

const NextStep = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-weight: 300;
    opacity: 0.75;

    ${theme.media('sm')} {
      ${hideVisually()}
    }
  `}
`

export default {
  ProgressWrapper,
  Header,
  Title,
  Intro,
  NextStep,
}
